import type { NotificationPreferences } from "@/components/notifications/manage-preferences";

export const DEFAULT_PREFERENCES: NotificationPreferences = {
  pushNotifications: true,
  emailNotifications: true,
  smsNotifications: true,
};
